/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const Modalupcoming = (props) => {
//   const {
//     buttonLabel,
//     className
//   } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button id = 'Upcoming'onClick={toggle}>
        <img  className = 'book-image'src ={props.book.cover} /> </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader className ='book-authitle' toggle={toggle}>
        <div>{props.book.title}</div> 
        <div>by: {props.book.author}</div>
        
        </ModalHeader>
        <ModalBody>
          {props.book.description}
        </ModalBody>
        </Modal>
    </div>
  );
}

export default Modalupcoming;